<template>
  <v-container>
    <div class="banner-wrap">
      <Banner class="pc-banner " :is-hitech="false" />
    </div>
    <div v-show="showOverlay" class="d-overlay" />
    <v-layout id="smart-agent-wrapper" column wrap justify-center>
      <v-flex xs6 class="smart-header flex-basis-auto">
        <AgentHeader />
      </v-flex>
      <v-flex>
        <Stepper />
        <LeavePage ref="leavePageDialog" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AgentHeader from '@/components/Smart_Agent/Header/AgentHeader';
import Stepper from '@/components/Smart_Agent/Stepper/Stepper';
import Banner from '@/components/Jobs_List/Banner';
import CurrentUser from '@/components/mixins/CurrentUser';
import LeavePage from '@/components/Dialogs/LeavePage/LeavePage';
import { mapState } from 'vuex';

export default {
  mixins: [CurrentUser],
  name: 'smartalertsPage',
  layout: 'smartAlerts',
  components: {
    AgentHeader,
    Stepper,
    Banner,
    LeavePage,
  },

  data() {
    return {
      showOverlay: false,
      confirm: false,
      answer: false,
    };
  },
  computed: {
    ...mapState({
      currentStep: (state) => state.authUser.smartAgent.currentStep,
    }),
  },

  created() {
    // this.redirectExcistingSmartAgentUser()
  },

  mounted() {
    this.$bus.$on('showOverlay', () => {
      this.showOverlay = true;

      this.$nextTick(() => {
        this.showOverlay = false;
      });
    });
    this.$bus.$on('hideOverlay', () => {
      this.showOverlay = false;
    });
  },

  methods: {
    redirectExcistingSmartAgentUser() {
      if (
        this.CurrentUser &&
        this.SmartAgentActive
        // this.CurrentUser.AlertSettings &&
        // this.CurrentUser.AlertSettings.Active
      ) {
        this.$router.push('/personal/smartalerts/');
      }
    },
    isMobile() {
      return window.innerWidth < 600;
    },
  },

  beforeDestroy() {
    this.$bus.$off('showOverlay');
    this.$bus.$off('hideOverlay');
  },

  /** page leave detect */
  async beforeRouteLeave(to, from, next) {
    const client = process.client;
    const exlude_personal = to.path
      .split('/')
      .includes('smartalertsnotification');
    if (this.isMobile() && client && !exlude_personal) {
      let answer = await this.$refs.leavePageDialog?.pop();
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
#smart-agent-wrapper .smart-header {
  max-width: 800px;
  margin: 0 auto;
}

.d-overlay {
  border-radius: inherit;
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
  will-change: opacity;
  opacity: 0.75;
  background-color: #000;
  border-color: rgb(33, 33, 33);
  z-index: 5;
}

.mobile-banner {
  margin: 5px;
}
</style>
